var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: "prompting-card-" + _vm.cardId,
      staticClass: "flex flex-col justify-between flex-grow h-full gap-2"
    },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center content-center justify-center h-full"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex w-full gap-4 pb-4 overflow-x-auto scrolling-touch snap-x-mandatory scrollbar-lg",
              class: {
                "max-w-56": _vm.sessionStatus === "draft",
                "max-w-72": _vm.sessionStatus !== "draft"
              },
              attrs: {
                id: "prompting-scroll-" + _vm.measurement.id,
                dir: "ltr"
              },
              on: { scroll: _vm.onScroll }
            },
            _vm._l(_vm.promptBoxesPages, function(promptBoxes, idx) {
              return _c(
                "div",
                {
                  key: _vm.measurement.id + "-prompt-boxes-" + (idx + 1),
                  staticClass:
                    "flex justify-center flex-shrink-0 w-full snap-center",
                  attrs: {
                    id: _vm.measurement.id + "-prompt-boxes-" + (idx + 1)
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-wrap items-start content-center justify-center w-full gap-x-2 gap-y-3",
                      class: { "-translate-y-1 scale-75": _vm.isCollapsed }
                    },
                    _vm._l(promptBoxes, function(prompt) {
                      return _c(
                        "div",
                        { key: prompt.key, staticClass: "space-y-1" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "relative flex items-center justify-center flex-shrink-0 border cursor-pointer hover-darker",
                              class: {
                                "h-12 w-12 xl:h-14 xl:w-14 rounded-xl":
                                  _vm.sessionStatus === "draft",
                                "h-18 w-18 rounded-3xl":
                                  _vm.sessionStatus !== "draft",
                                "cursor-wait":
                                  (_vm.scoreLoadingBox !== null &&
                                    _vm.scoreLoadingBox !== prompt.key) ||
                                  (_vm.typeLoadingBox !== null &&
                                    _vm.typeLoadingBox !== 1),
                                "pointer-events-none":
                                  _vm.sessionStatus !== "ongoing"
                              },
                              style: {
                                backgroundColor:
                                  _vm.promptColors[prompt.color].primaryColor,
                                borderColor:
                                  _vm.promptColors[prompt.color].secondaryColor,
                                color: _vm.promptColors[prompt.color].textColor
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onChangeScore(prompt, 1)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "absolute font-semibold top-px",
                                  class: {
                                    "text-xxs xl:text-xs":
                                      _vm.sessionStatus === "draft",
                                    "text-xs": _vm.sessionStatus !== "draft"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(prompt.abbreviation) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              prompt.score
                                ? _c(
                                    "div",
                                    { staticClass: "text-4xl font-bold" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(prompt.score) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "font-bold",
                                      class: {
                                        "text-3xl xl:text-4xl":
                                          _vm.sessionStatus === "draft",
                                        "text-5xl":
                                          _vm.sessionStatus !== "draft"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                +\n              "
                                      )
                                    ]
                                  )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center h-5 transition-all duration-300 border rounded cursor-pointer border-slate-500 bg-pure-white hover:bg-hover-state",
                              class: {
                                "w-12 xl:w-14": _vm.sessionStatus === "draft",
                                "w-18": _vm.sessionStatus !== "draft",
                                "cursor-wait":
                                  (_vm.scoreLoadingBox !== null &&
                                    _vm.scoreLoadingBox !== prompt.key) ||
                                  (_vm.typeLoadingBox !== null &&
                                    _vm.typeLoadingBox !== -1),
                                "pointer-events-none":
                                  !prompt.score ||
                                  _vm.sessionStatus !== "ongoing"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onChangeScore(prompt, -1)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "flex-shrink-0 w-6 h-1 transition-all duration-300 rounded",
                                class: {
                                  "bg-slate-500": !prompt.score,
                                  "bg-slate-600": prompt.score
                                }
                              })
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 pb-3 space-y-2",
          class: { "-translate-y-2": _vm.isCollapsed }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center justify-center h-3 gap-2" },
            _vm._l(_vm.pageCount, function(n) {
              return _c("div", {
                key: n,
                staticClass:
                  "w-3 h-3 transition-all duration-300 rounded-full cursor-pointer",
                class: {
                  "bg-slate-700": n === _vm.page,
                  "bg-slate-400": n !== _vm.page
                },
                on: {
                  click: function($event) {
                    return _vm.onChangePage(n)
                  }
                }
              })
            }),
            0
          ),
          _vm._v(" "),
          !_vm.isCollapsed
            ? _c("div", [
                _vm.measurement.target.prompting_format === "classic"
                  ? _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("BlTextBody2", { attrs: { text: "Goal:" } }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: _vm.measurement.target.goal }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "attempt(s)" } }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: _vm.measurement.target.success_metric }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "prompt" } })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.measurement.target.prompting_format === "custom"
                  ? _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c("BlTextBody2", { attrs: { text: "Goal:" } }),
                        _vm._v(" "),
                        _vm.measurement.target.success_metric ===
                        "equal to or greater than goal"
                          ? _c("BlTextBody2", { attrs: { text: "≥" } })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.measurement.target.success_metric ===
                        "less than goal"
                          ? _c("BlTextBody2", { attrs: { text: "<" } })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: _vm.measurement.target.goal + "%" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "pl-2",
                          attrs: { text: "Score" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: _vm.currentScore + "%" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sessionStatus === "draft"
            ? _c("BlInputButton", {
                staticClass: "w-full",
                attrs: {
                  type: "outlined",
                  dense: "",
                  label: "Customize prompt visibility"
                },
                on: {
                  clicked: function($event) {
                    _vm.customizePromptsOpened = true
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.customizePromptsOpened
        ? _c("CustomizePromptModal", {
            attrs: {
              measurementId: _vm.measurement.id,
              prompts: _vm.results,
              successMetric: _vm.measurement.target.success_metric
            },
            on: {
              "close-modal": function($event) {
                _vm.customizePromptsOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f5fe61e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5fe61e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/card/Prompting.vue
// module id = null
// module chunks = 